export const flowThreadUiCopy = {
  buttonPath: 'مسار الزر',
  listPath: 'مسار القائمة',
  mediaFileFallback: 'مرفق',
  inlineTextPlaceholder: 'اكتب النص هنا',
  inlineFooterPlaceholder: 'فوتر اختياري',
  viewList: 'عرض القائمة',
  chooseBelow: 'اختر من الخيارات أدناه',
  chooseList: 'اختر من القائمة التالية',
  listButtonPlaceholder: 'عرض الخيارات',
  listSectionPlaceholder: 'اسم القسم',
  listRowTitlePlaceholder: 'عنوان الخيار',
  listRowDescriptionPlaceholder: 'وصف مختصر',
  listRowsCounter: 'عدد الخيارات',
  listSectionsCounter: 'عدد الأقسام',
  listRowLimitReached: 'وصل هذا القسم إلى 10 خيارات.',
  listTotalLimitReached: 'رسالة القائمة تدعم 10 خيارات كحد أقصى.',
  listSectionTitleHint: 'عند وجود أكثر من قسم يصبح عنوان القسم مطلوبًا.',
  timestamp: '11:31 AM',
  messageAction: 'Message',
  saveContactAction: 'Save contact',
  phonePlaceholder: '9665XXXXXXXX',
  branchBack: 'العودة',
  branchNextStep: 'الخطوة التالية',
  branchPlaceholder: 'اسم الزر',
  deleteNode: 'حذف',
  addAfterButton: 'إضافة خطوة بعد الزر',
  addAfterRow: 'إضافة خطوة بعد الخيار',
  addButton: 'إضافة زر',
  addRow: 'إضافة خيار',
  addSection: 'إضافة قسم',
  exactMatch: 'Exact Match',
  containsMatch: 'Contains',
  keywordPlaceholder: 'اكتب الكلمة أو الجملة',
  keywordHint: 'يمكنك إدخال كلمة واحدة أو عدة كلمات مفصولة بفاصلة',
  noHeader: 'بدون هيدر',
  textHeader: 'هيدر نصي',
  mediaHeader: 'هيدر ميديا',
  headerTextPlaceholder: 'عنوان قصير للرسالة',
  mediaUpload: 'رفع ميديا',
  mediaLimits: 'الصورة: 5MB، الفيديو: 16MB، الملف: 100MB',
  mediaSizeError: size => `هذا الملف أكبر من حد واتساب ${size}MB.`,
  nodeTitlePlaceholder: 'عنوان النود',
};

export const flowThreadMessageTypes = [
  'text',
  'interactive',
  'carousel',
  'contact',
  'locationRequest',
  'image',
  'video',
  'audio',
  'file',
];

export const flowThreadBranchTypes = ['button', 'row'];

export const flowThreadStructuralTypes = [
  'start',
  'noMatch',
  'keyboard',
  'section',
];

export const flowThreadContinuationTypeMap = {
  text: 'رسالة نصية',
  interactive: 'رسالة تفاعلية',
  keyboard: 'قائمة تفاعلية',
  carousel: 'كاروسيل',
  image: 'صورة',
  video: 'فيديو',
  audio: 'صوت',
  file: 'ملف',
  contact: 'جهة اتصال',
  locationRequest: 'طلب موقع',
  start: 'بداية',
  noMatch: 'No Match',
  ai: 'ذكاء اصطناعي',
};
